import React from "react";
import { ExtraOption, ProductExtraOption } from "../../types";

export type SelectableOption<T = unknown> = ExtraOption<T>;

export const formatOptionLabelSaleProducts = (
    option: SelectableOption<ProductExtraOption>,
    { context }: { context: "menu" | "value" }
): React.ReactNode => {
    if (context === "value") return option.label;
    return (
        <div className="d-flex flex-column fs-7">
            <span className="fs-normal">{option.label}</span>
            {option.brand && <span className="option-color">{option.brand}</span>}
            {option.sku && <span className="option-color">{option.sku}</span>}
        </div>
    );
};
